import {useSelector} from "react-redux";
import {ToastContainer} from "react-toastify";
import {ReactQueryDevtools} from "@tanstack/react-query-devtools";
import {isMobile} from "react-device-detect";
import {useSearchParams} from "react-router-dom";

import Canvas from "components/Canvas";
import Header from "components/Layout/components/Header";
import ObjectPanel from "components/Layout/components/ObjectPanel";
import PropertyPanel from "components/Layout/components/PropertyPanel";
import CodeEditor from "components/CodeEditor";
import Tutorial from "components/Tutorial";
import Chatting from "components/Chatting";
import VoiceChat from "components/VoiceChat";
import Selfie from "components/Selfie";
import AudioPlayer from "components/AudioPlayer";
import TopBtnOptions from "components/TopBtnOptions";
import PopupPortal from "components/PopupPortal";
import IPXContents from "components/IPXContents";
import RotateGuide from "components/RotateGuide";
import RedbrickEventContents from "components/RedbrickEventContents";
import styles from "./index.module.scss";
import classNames from "classnames/bind";
import {useCallback, useEffect, useState} from "react";
// const Canvas = lazy(() => import("components/Canvas"));
// const Menus = lazy(() => import("components/Menus"));
// const CodeEditor = lazy(() => import("components/CodeEditor"));
// const Tutorial = lazy(() => import("components/Tutorial"));
// const Chatting = lazy(() => import("components/Chatting"));
// const VoiceChat = lazy(() => import("components/VoiceChat"));
// const Selfie = lazy(() => import("components/Selfie"));
// const AudioPlayer = lazy(() => import("components/AudioPlayer"));
// const TopBtnOptions = lazy(() => import("components/TopBtnOptions"));
// const PopupPortal = lazy(() => import("components/PopupPortal"));
// const IPXContents = lazy(() => import("components/IPXContents"));
// const RotateGuide = lazy(() => import("components/RotateGuide"));
const cn = classNames.bind(styles);
const View = ({
  isEditMode,
  isCodeEditorOpen,
  isSelfieMode,
  isIPXMode,
  isRedbrickEventMode,
  ipxProjectKey,
  redbrickEventProjectKey,
  isVerticalMode,
  isGstarUgcMode,
  onClickExit,
}) => {
  const mode = useSelector(state => state.mode);
  const isInDetailPlayPage = window.parent?.location.pathname === "/detail-play";
  const [searchParams, setSearchParams] = useSearchParams();
  const [isObjectPanelOpen, setObjectPanelOpen] = useState(false);
  const [isPropertyPanelOpen, setPropertyPanelOpen] = useState(false);
  const [isCodeMode, setisCodeMode] = useState(false);

  const isLearnMode = searchParams.get("mode") === "learn";

  const handleObjectPanel = useCallback(() => {
    setObjectPanelOpen(prev => !prev);
  }, []);

  const handlePropertyPanel = useCallback(() => {
    setPropertyPanelOpen(prev => !prev);
  }, []);

  const handleCodeMode = useCallback(() => {
    setisCodeMode(prev => !prev);
  }, []);

  useEffect(() => {
    searchParams.delete("token");
    setSearchParams(searchParams);
  }, []);

  return (
    <>
      <ReactQueryDevtools initialIsOpen={false} />
      {isVerticalMode && isMobile && <RotateGuide />}
      <div className={styles.container} id="studio">
        {isEditMode && (
          <Header
            isPropertyPanelOpen={isPropertyPanelOpen}
            isObjectPanelOpen={isObjectPanelOpen}
            isCodeMode={isCodeMode}
            handleObjectPanel={handleObjectPanel}
            handlePropertyPanel={handlePropertyPanel}
            handleCodeMode={handleCodeMode}
          />
        )}

        <div className={isEditMode ? styles.main : styles.main_play}>
          {isLearnMode && (
            <div className={styles.tutorial_container}>
              <Tutorial />
            </div>
          )}

          <div className={styles.canvas_wrapper}>
            {isEditMode && (
              <ObjectPanel isObjectPanelOpen={isObjectPanelOpen} isCodeMode={isCodeMode} handleObjectPanel={handleObjectPanel} />
            )}
            <section id="canvas_container" className={cn("canvas", isPropertyPanelOpen && "canvas_collapsed")}>
              <Canvas isIPXMode={isIPXMode} />
              {!isEditMode && <Chatting isIPXMode={isIPXMode} />}
              {!isEditMode && <VoiceChat />}
              {!isEditMode && <Selfie isIPXMode={isIPXMode} />}

              {isEditMode && <AudioPlayer />}
              {isCodeEditorOpen && <CodeEditor />}
              {isMobile && !isInDetailPlayPage && <button className="studio_exit_btn" onClick={onClickExit} />}
              {/* {!isEditMode && !isSelfieMode && !isGstarUgcMode && <TopBtnOptions isIPXMode={isIPXMode} onClickExit={onClickExit} />} */}
              {isIPXMode && <IPXContents ipxProjectKey={ipxProjectKey} />}
              {isRedbrickEventMode && <RedbrickEventContents redbrickEventProjectKey={redbrickEventProjectKey} />}
            </section>

            {isEditMode && <PropertyPanel isPropertyPanelOpen={isPropertyPanelOpen} handlePropertyPanel={handlePropertyPanel} />}
          </div>
        </div>
        <ToastContainer />
      </div>
      <PopupPortal />
    </>
  );
};

export default View;
